import React from "react";
import {
    TableHead,
    TableRow,
    TableCell,
    TableSortLabel,
    Box
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { COLUMNS } from "./constants";

export const WebhooksTableHead = ({ sortConfig, onSortChange }) => {
    const { orderBy, order } = sortConfig || { orderBy: "status", order: "desc" };

    const handleSort = (column) => {
        if (onSortChange) {
            onSortChange(column);
        }
    };

    return (
        <TableHead>
            <TableRow>
                {COLUMNS.map(({ key, label, sortable, width }) => (
                    <TableCell
                        key={key}
                        sx={{ width }}
                        sortDirection={orderBy === key ? order : false}
                    >
                        {sortable ? (
                            <TableSortLabel
                                active={orderBy === key}
                                direction={orderBy === key ? order : "asc"}
                                onClick={() => handleSort(key)}
                                sx={{
                                    "&.MuiTableSortLabel-root": {
                                        color: "inherit"
                                    },
                                    "&.MuiTableSortLabel-root:hover": {
                                        color: "primary.main"
                                    },
                                    "&.Mui-active": {
                                        color: "primary.main"
                                    },
                                    "& .MuiTableSortLabel-icon": {
                                        color: "primary.main !important"
                                    }
                                }}
                            >
                                {label}
                                {orderBy === key ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        ) : (
                            label
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};
